<div *ngIf="services" [ngClass]="{ 'mt-top-end-navbar': !isFromModal }" class="container-fluid">
	<div class="row justify-content-md-center">
		<div class="col-12">
			<mat-card [ngClass]="{ 'shadow-sm': !isFromModal }" class="card border-0">
				<div *ngIf="!isFromModal" class="media border-0">
					<a class="info" href="https://openfiber.it/it/fibra-ottica/occhio-al-bollino" target="_ftth">
						<img class="mr-3" src="./assets/imgs/markers/ftth.png?v={{ assets_version }}" alt="FTTH" />
					</a>
					<div class="title-1">
						{{ "SERVICES_MENU.POINT_TO_POINT" | translate }}
					</div>
				</div>

				<ng-container *ngFor="let service of services.p2pServices">
					<!-- dark fiber -->
					<div *ngIf="service.name.toLowerCase() == 'dark fiber'" class="card-body border-0">
						<div class="title-2">
							{{ service.name }}
						</div>
						<p *ngIf="service.description">{{ service.description }}</p>

						<div *ngFor="let subService of service.sub_services" class="sub-service">
							<div *ngIf="subService.name" class="title-4 mb-2">
								{{ subService.name }}
							</div>
							<div class="mb-2">
								{{ subService.description }}
							</div>

							<div *ngFor="let pricelist of subService.pricelists" class="pricelist">
								<div *ngFor="let priceItem of pricelist | keyvalue">
									<strong>{{ priceItem.value.prices.label }}</strong>
									<ul>
										<li>NRC (Non Recurring Charge): € {{ priceItem.value.prices.nrc }}</li>
										<li>MRC (Monthly Recurring Charge): € {{ priceItem.value.prices.mrc }}</li>
										<li>Contract duration: {{ priceItem.value.prices.contract_duration }} year</li>
									</ul>
								</div>
							</div>

							<ng-container *ngIf="userdata && authService.isAdmin">
								<p>
									<strong>Direct connection</strong>
									: the A-End and B-End is directly connected in the same OF Point of Presence Area
								</p>

								<p>
									<strong>Indirect Connection</strong>
									: A-End and B-End are connected in different OF Point of Presence Area
								</p>
							</ng-container>

							<p>
								In the Rural Area (Cluster C&D) the P2P Dark Fiber service are available only with A-End
								the OF local Point of Presence and the B-end an address covered by the same POP with NRC
								= € 593,78 and MRC = € 33,6.
							</p>

							<span>
								<strong>{{ "SERVICES.PRICE_LIST_IRU" | translate }}:</strong>
							</span>
							<span>{{ "SERVICES.BASED_ON_FEASIBILITY" | translate }}</span>
							<div class="my-3">
								<p class="vat">{{ "SERVICES.VAT_EXCLUDED" | translate }}</p>
								<ng-content></ng-content>
							</div>
						</div>
					</div>

					<!-- bea -->
					<div *ngIf="service.name.toLowerCase() != 'dark fiber'" class="card-body border-0">
						<div class="title-2">
							{{ service.name }}
						</div>
						<ng-container *ngFor="let subService of service.sub_services">
							<div class="mt-3">
								<div *ngIf="subService.name" class="title-4 mb-2">
									{{ subService.name }}
								</div>
								<div class="mb-2">
									{{ subService.description }}
								</div>
								<ng-container *ngIf="service.name.toLowerCase() === 'dark fiber'">
									<ng-container *ngFor="let price of subService.pricelists">
										<span class="font-weight-bold mb-2">
											Price list with {{ price.prices.contract_duration }} year minimum contract
											{{ price.type === "OUT" ? "outside" : "in" }}
											Urban Area
											<span *ngIf="price.cities">{{ price.cities.join() }}</span>
											<span *ngIf="price.km_range !== 'ALL' && returnRange(price.km_range)">
												({{ "SERVICES.RANGE" | translate }} :
												{{ returnRange(price.km_range) }} km)
											</span>
											<span *ngIf="price.type && authService.isAdmin" class="text-uppercase">
												-
												<strong>{{ price.type }}</strong>
											</span>
										</span>

										<ul>
											<li>
												{{ "SERVICES.NRC" | translate }}:
												<span>€ {{ price.prices.nrc }}</span>
											</li>
											<li *ngIf="price.prices.mrc">
												{{ "SERVICES.MRC" | translate }}:
												<span>€ {{ price.prices.mrc }}</span>
											</li>
											<li *ngIf="price.prices.yrc">
												{{ "SERVICES.YRC" | translate }}:
												<span>{{ price.prices.yrc }} € / m</span>
											</li>
											<li>
												{{ "SERVICES.CONTRACT_DURATION" | translate }}
												<span>
													{{ price.prices.contract_duration }}
													{{ "GENERAL.YEAR" | translate }}
												</span>
											</li>
										</ul>
									</ng-container>

									<ng-container *ngIf="userdata && authService.isAdmin">
										<p>
											<strong>Direct connection</strong>
											: the A-End and B-End is directly connected in the same OF Point of Presence
											Area
										</p>

										<p>
											<strong>Indirect Connection</strong>
											: A-End and B-End are connected in different OF Point of Presence Area
										</p>
									</ng-container>

									<p>
										In the Rural Area (Cluster C&D) the P2P Dark Fiber service are available only
										with A-End the OF local Point of Presence and the B-end an address covered by
										the same POP with NRC = € 593,78 and MRC = € 33,6.
									</p>

									<span>
										<strong>{{ "SERVICES.PRICE_LIST_IRU" | translate }}:</strong>
									</span>
									<span>{{ "SERVICES.BASED_ON_FEASIBILITY" | translate }}</span>
									<div class="my-3">
										<p class="vat">{{ "SERVICES.VAT_EXCLUDED" | translate }}</p>
										<ng-content></ng-content>
									</div>
								</ng-container>

								<ng-container *ngIf="service.name.toLowerCase() === 'ethernet'">
									<div class="my-3">
										<div class="title-4 mb-2">
											{{ "SERVICES.FEES" | translate }}
										</div>

										<ng-container>
											<ng-container *ngIf="subService.name === 'BEA'">
												<ng-container
													*ngFor="let pricelist of subService.pricelists | keyvalue"
												>
													<span>
														<strong>
															{{ pricelist.key }} standard price with
															{{ pricelist.value.AB.prices.contract_duration }} year
															minimum contract:
														</strong>
													</span>
													<div class="my-4 d-flex price-table">
														<div>
															<div class="table-box"></div>
															<div class="table-box table-title">
																NRC (Non Recurring Charge)
															</div>
															<div class="table-box table-title">
																MRC (Monthly Recurring Charge)
															</div>
														</div>

														<ng-container *ngFor="let v of pricelist.value | keyvalue">
															<div *ngIf="v.key === 'AB'">
																<div class="table-box table-title">Urban Area</div>
																<div class="table-box">€ {{ v.value.prices.nrc }}</div>
																<div class="table-box">€ {{ v.value.prices.mrc }}</div>
															</div>
															<div *ngIf="v.key === 'CD'">
																<div class="table-box table-title">Rural Area</div>
																<div class="table-box">€ {{ v.value.prices.nrc }}</div>
																<div class="table-box">€ {{ v.value.prices.mrc }}</div>
															</div>
														</ng-container>
													</div>
												</ng-container>
											</ng-container>

											<ng-container *ngIf="subService.name === 'BEL'">
												<ng-container
													*ngFor="let pricelist of subService.pricelists | keyvalue"
												>
													<span>
														<strong>
															{{ pricelist.key }} standard price with
															{{ pricelist.value.AB.prices.contract_duration }} year
															minimum contract:
														</strong>
													</span>
													<div class="my-4 d-flex price-table">
														<div>
															<div class="table-box"></div>
															<div class="table-box table-title">
																NRC (Non Recurring Charge)
															</div>
															<div class="table-box table-title">
																MRC (Monthly Recurring Charge)
															</div>
														</div>
														<ng-container *ngFor="let v of pricelist.value | keyvalue">
															<div *ngIf="v.key === 'AB'">
																<div class="table-box table-title">Urban Area</div>
																<div class="table-box">€ {{ v.value.prices.nrc }}</div>
																<div class="table-box">€ {{ v.value.prices.mrc }}</div>
															</div>
															<div *ngIf="v.key === 'CD'">
																<div class="table-box table-title">Rural Area</div>
																<div class="table-box">€ {{ v.value.prices.nrc }}</div>
																<div class="table-box">€ {{ v.value.prices.mrc }}</div>
															</div>
														</ng-container>
													</div>
												</ng-container>
											</ng-container>
										</ng-container>
										<p *ngIf="subService.name === 'BEA' && isFromModal">
											<a href="javascript:void(0)" (click)="checkBea.emit()">
												Check fast BEA feasibility
											</a>
										</p>
										<p class="vat">{{ "SERVICES.VAT_EXCLUDED" | translate }}</p>
									</div>
								</ng-container>
							</div>
						</ng-container>
					</div>
				</ng-container>
			</mat-card>
		</div>
	</div>
</div>
